import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  constructor(private ngSelectConfig: NgSelectConfig) {
    this.ngSelectConfig.clearAllText = "Clear";
  }

  ngOnInit(): void { }
}
